import { AUDIENCE_TYPES, POST_TYPES, TOPICS } from "posts/constants";

import React from "react";
import intersection from "lodash.intersection";
import u from "updeep";

export const FeedStateContext = React.createContext();
export const FeedDispatchContext = React.createContext();

const DEFAULT_AUDIENCE_TYPE = null;

export const feedInitialState = {
  audience: DEFAULT_AUDIENCE_TYPE,
  narratives: [],
  filters: {
    postTypes: {
      [POST_TYPES.ARTICLE]: true,
      [POST_TYPES.PHOTO]: true,
      [POST_TYPES.MUSIC]: true,
      [POST_TYPES.TWITTER]: true,
      [POST_TYPES.VIDEO]: true,
      [POST_TYPES.TV]: true,
    },
    narratives: {
      showInsights: true,
      narrativesOnly: false,
    },
    topics: {
      [TOPICS.POVERTY]: true,
      [TOPICS.COVID]: true,
      [TOPICS.BLM]: true,
    },
  },
  activePosts: [],
  posts: [],
};

const getActivePosts = ({ posts, audience, narratives, filters }) => {
  return posts
    .filter((p) => {
      // If no filters are set for this type, show everything
      if (!audience) return true;
      if (!p.audiences) return true;
      return p.audiences.includes(audience);
    })
    .filter((p) => {
      // Get an array of all of the values for this filter type
      const values = Object.keys(filters.postTypes).map(
        (k) => filters.postTypes[k]
      );
      return filters.postTypes[p.type];
    })
    .filter((p) => {
      // Get an array of all of the values for this filter type
      const values = Object.keys(filters.topics).map((k) => filters.topics[k]);

      // If this post doesn't have topics, always show it
      if (!p.topics || !p.topics.length) {
        return true;
      }
      // Get an array of all of the topics that are currently checked
      const selectedTopics = Object.keys(filters.topics).reduce((acc, key) => {
        if (filters.topics[key]) {
          return [...acc, key];
        }
        return acc;
      }, []);
      return Boolean(intersection(selectedTopics, p.topics).length);
    })
    .filter((p) => {
      if (filters.narratives.narrativesOnly) {
        if (p.povertyNarratives && p.povertyNarratives.length) {
          return true;
        } else {
          return false;
        }
      }
      // FIXME: Figure out the logic for this filter once we have a final data structure
      // if (filters.narratives.showInsights) {
      //   if (p.insights && p.insights.length) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // }
      return true;
    });
};

export const feedReducer = function (state = feedInitialState, action) {
  switch (action.type) {
    case "set-posts": {
      const newState = u(
        {
          posts: u.constant(action.payload),
        },
        state
      );
      return u(
        {
          ...newState,
          activePosts: u.constant(getActivePosts(newState)),
        },
        state
      );
    }

    case "set-audience": {
      const newState = u(
        {
          audience: u.constant(action.payload),
        },
        state
      );

      return u(
        {
          ...newState,
          activePosts: u.constant(getActivePosts(newState)),
        },
        state
      );
    }

    case "set-narratives": {
      const newState = u(
        {
          narratives: u.constant(action.payload),
        },
        state
      );
      return u(
        {
          ...newState,
          activePosts: u.constant(getActivePosts(newState)),
        },
        state
      );
    }

    case "set-filter": {
      const newState = u.updateIn(
        `filters.${action.payload.path}`,
        action.payload.value,
        state
      );
      return u(
        {
          ...newState,
          activePosts: u.constant(getActivePosts(newState)),
        },
        state
      );
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};
